import withMetadataArgument from './withMetadataArgument.js'
import { isSupportedCountry as _isSupportedCountry } from '../../core/index.js'

export function isSupportedCountry() {
	return withMetadataArgument(_isSupportedCountry, arguments)
}


//////////////////
// WEBPACK FOOTER
// ./~/libphonenumber-js/min/exports/isSupportedCountry.js
// module id = 1163
// module chunks = 22